import { render, staticRenderFns } from "./NewParent.vue?vue&type=template&id=3c4a411a"
import script from "./NewParent.vue?vue&type=script&lang=js"
export * from "./NewParent.vue?vue&type=script&lang=js"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NewParent.vue?vue&type=style&index=1&id=3c4a411a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports